import React from 'react';
import classNames from 'classnames';

import { StagesMenuLayerItem } from '../../types';
import { MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import MatchMenuItem from './MatchMenuItem';
import StageMenuItem from './StageMenuItem';

import styles from '../../styles/LeftMenu.module.scss';

type StagesAndMatchesMenuItemsProps = {
  list: StagesMenuLayerItem[];
};

const StagesAndMatchesMenuItems: React.FC<StagesAndMatchesMenuItemsProps> = ({ list }) => {
  return (
    <ul className={classNames(styles.layerMenuItems, styles.stagesAndMatchesMenuItems)}>
      {list.map((item) => {
        if (item.type === MENU_ITEM_TYPE.STAGE) {
          return (
            <StageMenuItem entry={item}
                           key={item.key} />
          );
        }
        else if (item.type === MENU_ITEM_TYPE.MATCH) {
          return (
            <MatchMenuItem entry={item}
                           key={item.key} />
          );
        }

        return null;
      })}
    </ul>
  );
};

export default StagesAndMatchesMenuItems;
